import { useMemo } from "react";
import { wrapText } from "../../../utils/helpers";

export interface AnalysisLstatTextWrapProps {
  text: string,
  width: number
}

const AnalysisLstatTextWrap = ({text, width}: AnalysisLstatTextWrapProps) => {
  const wrappedText = useMemo(() => {
    const textList = wrapText(text, width);
    return textList;
  }, [text]);

  return (
    <>
      {
        wrappedText.map((word, index) => (
          <tspan key={`text-wrapped-${word}-${index}`} x={0} dy={12}>
            {word}
          </tspan>
        ))
      }
    </>
  );
};

export default AnalysisLstatTextWrap;
